export default {
        Declined: 0,
        Approved: 1,
        Reviewed: 2,
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/config/reviewItemStatuses.constant.js